import React from "react";
import {Stack} from "@mui/material";
import {Description} from "@mui/icons-material";
import PageTitle from "./layout/PageTitle.js";
import ButtonCreate from "./layout/ButtonCreate.js";
import Loader from "./layout/loading/loader.js";
import Constants from "../../utils/constants.js";
import {toastHelper} from "../../utils/toast-helper.js";
import ModeOperatoireTable from "./referentiel/modesOperatoires/ModeOperatoireTable.js";
import {useGetModesOperatoiresQuery, useDeleteModeOperatoireMutation} from "../../modules/modesOperatoires/modesOperatoires.api.js";

export default function ModesOperatoiresPage() {
    const {data: modes = [], isLoading} = useGetModesOperatoiresQuery();
    const [deleteModeOperatoire] = useDeleteModeOperatoireMutation();

    const handleDelete = async (m) => {
        try {
            await deleteModeOperatoire(m.id).unwrap();
            toastHelper.displaySuccess("Mode opératoire supprimé.");
        } catch (e) {
            toastHelper.handleError(e, "Oops, une erreur est survenue.");
        }
    };

    return (
        <>
            <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
                <PageTitle title={"Modes opératoires"} icon={<Description/>}/>
                <ButtonCreate route={Constants.APP_ROUTE_ADMIN_MODES_OPERATOIRES_NEW} label={"Ajouter un mode opératoire"}/>
            </Stack>

            {isLoading ? <Loader/> : <ModeOperatoireTable modes={modes} onDelete={handleDelete}/>}
        </>
    );
}
